import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import {
  FaPlus,
  FaFilter,
  FaRedo,
  FaTrashAlt,
  FaEdit,
  FaSearch,
  FaEye,
} from "react-icons/fa";

const TimeSlotTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8; // Items per page
  const [data, setData] = useState([
    {
      name: "Morning Slot",
      startTime: "09:00 AM",
      endTime: "10:30 AM",
      lecturer: "Dr. Jane Doe",
      division: "1st Sem",
      status: "Active",
    },
    {
      name: "Afternoon Slot",
      startTime: "01:00 PM",
      endTime: "02:30 PM",
      lecturer: "Prof. John Smith",
      division: "1st Sem",
      status: "Inactive",
    },
  ]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <Card
      className="p-3"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Time Slots</h4>
        <div className="d-flex align-items-end">
        <Button variant="primary" className="d-flex align-items-center me-3">
            <FaPlus className="me-2" /> Add 
          </Button>
          <div className="position-relative me-2" style={{ width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaSearch
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
         
        </div>
      </div>
      <Card.Body style={{ flexGrow: 1, overflow: "auto" }}>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Lecturer</th>
              <th>Division</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.startTime}</td>
                <td>{item.endTime}</td>
                <td>{item.lecturer}</td>
                <td>{item.division}</td>
                <td>
                  <span
                    className={`badge ${
                      item.status === "Active"
                        ? "bg-success"
                        : "bg-secondary"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle variant="light" size="sm" className="border-0">
                      Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item>
                        <FaEye className="me-2 text-info" /> View
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <FaEdit className="me-2 text-primary" /> Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(index)}>
                        <FaTrashAlt className="me-2 text-danger" /> Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
            {!paginatedData.length && (
              <tr>
                <td colSpan="7" className="text-center">
                  No results found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span>
            Showing {startIndex + 1}-{Math.min(startIndex + itemsPerPage, filteredData.length)} of {filteredData.length} entries
          </span>
          <Pagination>
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} />
          </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TimeSlotTable;
